import React from "react";
import { Reveal } from "@/components/Reveal";

// Renders long-form SEO content blocks in an editorial style.
export default function LongForm({ data, dark = false }) {
  const text = dark ? "text-white/70" : "text-ink/70";
  const heading = dark ? "text-white" : "text-ink";
  const accent = "text-aqua";

  return (
    <div className="max-w-3xl">
      {data.intro && (
        <Reveal>
          <p className={`text-xl leading-relaxed ${dark ? "text-white/85" : "text-ink/85"} font-medium border-l-2 border-aqua pl-6`}>
            {data.intro}
          </p>
        </Reveal>
      )}
      <div className="mt-10 space-y-6">
        {data.blocks.map((b, i) => {
          if (b.type === "h2")
            return (
              <Reveal key={i} delay={0.02}>
                <h2 className={`text-2xl sm:text-3xl font-bold tracking-tight mt-10 ${heading}`}>{b.text}</h2>
              </Reveal>
            );
          if (b.type === "h3")
            return (
              <Reveal key={i}>
                <h3 className={`text-xl font-bold mt-6 ${heading}`}>{b.text}</h3>
              </Reveal>
            );
          if (b.type === "ul")
            return (
              <Reveal key={i}>
                <ul className="space-y-2.5">
                  {b.items.map((it, k) => (
                    <li key={k} className={`flex gap-3 text-lg leading-relaxed ${text}`}>
                      <span className={`font-bold ${accent}`}>→</span> {it}
                    </li>
                  ))}
                </ul>
              </Reveal>
            );
          return (
            <Reveal key={i}>
              <p className={`text-lg leading-relaxed ${text}`}>{b.text}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
}
